export default {
    'widgets.swap-form.header.swap': 'Tausch',
    'widgets.swap-form.input.title.you_pay': 'Sie zahlen',
    'widgets.swap-form.input.title.you_receive': 'Sie erhalten',
    'widgets.swap-form.input.balance.balance': 'Kontostand',
    'widgets.swap-form.fusion-info.slippage-tolerance': 'Toleranz für Slippage',
    'widgets.swap-form.fusion-info.auction-time': 'Auktionszeit',
    'widgets.swap-form.fusion-info.min-receive': 'Mindestempfang',
    'widgets.swap-form.fusion-info.net-fee': 'Netzwerkgebühr',
    'widgets.swap-form.swap-button.confirm-swap': 'Tausch bestätigen',
    'widgets.swap-form.swap-button.update-swap-data': 'Tauschpfad wird gesucht',
    'widgets.swap-form.swap-button.check-allowance': 'Zulage überprüfen',
    'widgets.swap-form.swap-button.native-token-not-supported': 'Nativer Token wird derzeit nicht unterstützt',
    'widgets.swap-form.swap-button.approve-and-swap': 'Genehmigen und tauschen',
    'widgets.swap-form.swap-button.permit-and-swap': 'Erlauben und tauschen',
    'widgets.swap-form.swap-button.connect-wallet': 'Wallet verbinden',
    'widgets.swap-form.swap-button.select-source-token': 'Quellen-Token auswählen',
    'widgets.swap-form.swap-button.select-destination-token': 'Ziel-Token auswählen',
    'widgets.swap-form.swap-button.enter-amount-to-swap': 'Betrag zum Tauschen eingeben',
    'widgets.swap-form.swap-button.no-liquidity-for-swap': 'Keine Liquidität für den Tausch',
    'widgets.swap-form.swap-button.insufficient-balance': 'Unzureichendes Guthaben von {{symbol}}',
    'widgets.swap-form.swap-button.set-max': 'Maximalen {{symbol}} festlegen',
    'widgets.swap-form.swap-button.wait-wallet-response': 'Auf Wallet-Antwort warten',
    'widgets.swap-form.swap-button.permit-swap-in-wallet': 'Tausch im Wallet erlauben',
    'widgets.swap-form.swap-button.allow-swap-in-wallet': 'Tausch im Wallet zulassen',
    'widgets.swap-form.swap-button.wallet-rejected': 'Wallet hat die Anfrage abgelehnt',
    'widgets.swap-form.swap-button.swap-error-message': 'Tauschfehler',
    'widgets.swap-form.swap-button.waiting-approve-transaction': 'Warten auf Token-Genehmigung',
};
//# sourceMappingURL=de.js.map